import FieldErrorList from 'Components/FieldErrorList'
import type { FC } from 'react'

interface FieldErrorsProps {
  error: string[]
  identifier: string
}

const ServiceProviderFieldErrors: FC<FieldErrorsProps> = ({ error, identifier }) => {
  return (
    <FieldErrorList>
      {error.map((err: string, index: number) => (
        <li key={`${identifier}_${index}`}>{err}</li>
      ))}
    </FieldErrorList>
  )
}

export default ServiceProviderFieldErrors
